import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { Button, DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../../stores/applications/selectors';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { assignUsersApplications } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';
import MultiSelect from '../../common/MultiSelect';
import { userOptions } from '../../../stores/users/selectors';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    users: Array<{ label: string, value: string }>;

    assignUsersApplications: (usersIds: string[], applicationIds: string[]) => void;
}
interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
}

class AssignApplicationsUsersAction extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
      selection: [],
      showModal: false,
    };
  }

  public render() {
    const t = this.props.translate;
    if (
      this.props.hasPrivilege([
        'ASSIGN_USER_APPLICATION',
        'USER_ADMIN',
        'SUPER_ADMIN',
      ])
    ) {
      return (
        <React.Fragment>
          <DropdownItem
            className='no-icon'
            onClick={() => {
              this.setState({ showModal: true });
            }}>
            {t('applications.button.assignUsers')}
          </DropdownItem>
          <ConfirmModal
            className='overflow-visible'
            header={t('applications.modal.assignUsers.header') as string}
            confirmText={t('modal.assign') as string}
            isOpen={this.state.showModal}
            confirm={() => {
              this.assign();
            }}
            cancel={() => {
              this.setState({ showModal: false });
            }}>
            <p>{t('applications.modal.assignUsers.text') as string}</p>
            <Select className={"dropdown-select user-select"}
              isMulti={true}
              options={this.props.users.sort((a, b) => {
                  if (a.label.toLowerCase() < b.label.toLowerCase()) {
                    return -1;
                  } else {
                    return 1;
                  }
                })
              }
              value={this.state.selection}
              onChange={this.handleSelectChange}
            />
          </ConfirmModal>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  private handleSelectChange = (
    val?: ValueType<{ label: string; value: string }>
  ) => {
    this.setState({ selection: val === null || val === undefined ? [] : val });
  };

  private assign = () => {
    if (
      this.state.selection &&
      Array.isArray(this.state.selection) &&
      this.state.selection.length > 0
    ) {
      this.props.assignUsersApplications(
        this.state.selection.map(option => option.value),
        this.props.selected
      );
    }
  };
}

const mapStateToProps = (state: RootState) => ({
    users: userOptions(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'applications'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    assignUsersApplications: (ids: string[], applicationIds: string[]) =>
        dispatch(assignUsersApplications(ids, applicationIds)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(AssignApplicationsUsersAction));